import { PDxListItem } from "src/app/core/PDxListItem.model";

export class VERelationshipInformation {
    constructor() {
        this.hierarchy = [];
        this.masterHierarchy = [];
    }

    hierarchy: PDxListItem<string>[];
    vendorId: string;
    entityId: string;
    vendorName: string;
    isAudited: boolean;
    allowOrderUnderMinimum: boolean;
    vendorAccountNumber: string;
    contractNumber: string;
    contractExpDate: string;
    minOrderAmount: number;
    minOrderPenalty: number;
    additionalFees: number;
    formularyLock: boolean;
    masterFileInherit: boolean;
    chosenMasterFileId: string;
    masterIsFormulary: boolean;
    masterFiles: PDxListItem<string>[];
    masterHierarchy: PDxListItem<string>[];
    billingAccountNumber: string;
    addAssignment: boolean;
    stockingLocationId: number;
    stockingLocations: PDxListItem<number>[];
}